<div style="padding-top:50px;">
  <app-slider></app-slider>
</div>
